export const STATES = {
  idle: "idle",
  submitting: "submitting",
  loading: "loading",
};

export const isSubmitting = (state) => state === STATES.submitting;

export const isLoading = (state) => state === STATES.loading;
